import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Constants } from 'src/app/constants';
import { PalleteTypeService } from 'src/app/service/asn/pallet-type.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ShipmentsService } from 'src/app/service/document-control/shipments.service';
import { ExportStateService } from 'src/app/service/export-state.service';

@Component({
    selector: 'app-add-shipments-data',
    templateUrl: './add-shipments-data.component.html',
    styleUrls: ['./add-shipments-data.component.scss'],
    standalone: false
})
export class AddShipmentsDataComponent implements OnInit {

  heading: string;
  errormsg
  partValue
  grossWeight
  netWeight
  pallets
  sets
  freightType
  invoiceNumber
  emptypackagingValue
  emptypackagingKG
  shipmentDate
  shipmentType
  supplier
  shipmentid = "Auto Assigned";
  selected_position_id: any;
  TierData: any;
  supplierDropdown: any;
  shipmentTypeDropDown: any;
  freightTypeDropDown: any;
  userId: any;

  constructor(public dialogRef: MatDialogRef<AddShipmentsDataComponent>, private readonly constants: Constants,
    @Inject(MAT_DIALOG_DATA) public dataStore: any, private readonly shipmentsService: ShipmentsService,
    private readonly ngxUiLoaderService: NgxUiLoaderService, private readonly exportStateService: ExportStateService) { }

  ngOnInit(): void {
    this.heading = this.dataStore.header;
    this.supplierDropdown = this.dataStore.supplierDropdown;
    this.shipmentTypeDropDown = this.dataStore.shipmentTypeDropDown;
    this.freightTypeDropDown = this.dataStore.freightTypeDropDown;
  }

  validate(event: any, module) {
    const t = event.target.value;
    if (module == "value") { // NOSONAR
      event.target.value =
        t.indexOf('.') >= 0 ? t.substr(0, t.indexOf('.')) + t.substr(t.indexOf('.'), 3) : t;
    } else if (module == "kg") { // NOSONAR
      event.target.value =
        t.indexOf('.') >= 0 ? t.substr(0, t.indexOf('.')) + t.substr(t.indexOf('.'), 4) : t;
    }
  }

  close(): void {
    this.dialogRef.close(
      { event: 'CloseEvent' }
    );
  }
  onNoClick(): void {
    this.dialogRef.close({
      event: "NoEvent"
    });
  }

  keyPressAlphaNumeric(event) {
    const inp = String.fromCharCode(event.keyCode);
    if (/[.0-9]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  keyPressNumericInvoice(event) {
    const inp = String.fromCharCode(event.keyCode);
    if (/[0-9]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }
  
  public saveClick() {
    this.errormsg = ""
    const invalid = "invalid decimal"
    if (this.isValueOk(this.supplier)) {
      this.showError(this.constants.formInputError);
    } else if (this.isValueOk(this.shipmentDate)) {
      this.showError(this.constants.formInputError);
    } else if (this.isValueOk(this.shipmentType)) {
      this.showError(this.constants.formInputError);
    } else if (this.emptypackagingKG?.toString().split(".").length > 2) {
      this.showError(invalid);
    } else if (this.emptypackagingValue?.toString().split(".").length > 2) {
      this.showError(invalid);
    } else if (this.netWeight?.toString().split(".").length > 2) {
      this.showError(invalid);
    } else if (this.grossWeight?.toString().split(".").length > 2) {
      this.showError(invalid);
    } else if (this.partValue?.toString().split(".").length > 2) {
      this.showError(invalid);
    } else {
      this.saveAPICall();
    }
  }

  saveAPICall() { // NOSONAR
    const userData = sessionStorage?.getItem('FGA');
    if (userData)
    {
      this.userId = JSON.parse(userData)?.user?.userPrincipalName;
    }
    this.errormsg = ""
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    const updateObject = {
      userId: this.userId,
      flag: 0,
      p_supplier: this.supplier,
      shipmentTypeId: Number(this.shipmentType),
      shipmentDate: this.shipmentDate,
      emptyPackagingKg: this.emptypackagingKG == "" ? null : Number(this.emptypackagingKG?.toString().includes('.') ? this.emptypackagingKG?.toString().split(".")[0] + "." + this.emptypackagingKG?.toString().split(".")[1]?.substring(0, 3) : this.emptypackagingKG), // NOSONAR
      emptyPackagingValue: this.emptypackagingValue == "" ? null : Number(this.emptypackagingValue?.toString().includes('.') ? this.emptypackagingValue?.toString().split(".")[0] + "." + this.emptypackagingValue?.toString().split(".")[1]?.substring(0, 2) : this.emptypackagingValue), // NOSONAR
      p_numbers: Number(this.invoiceNumber),
      freightTypeId: Number(this.freightType),
      p_sets: this.sets,
      p_pallets: this.pallets,
      netWeight: this.formatToDecimal(this.netWeight, 3),
      grossWeight: this.formatToDecimal(this.grossWeight, 3) ,
      partValue: this.formatToDecimal(this.partValue, 2) 
    }
    this.shipmentsService.addEditShipment(updateObject).subscribe(
      response => {
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        if (response == "Shipment Added Successfully" || response == "Shipment and Invoices Added Successfully") { // NOSONAR
          this.dialogRef.close({
            event: "SaveEvent"
          });
        } else {
          this.showError(response);
        }
      }, _error => {
        this.showError(this.constants.APIErrorMessage);

      });

  }

  formatToDecimal(value: any, decimalPlaces: number): any {
    if (value == '' || value == undefined || value == null) { // NOSONAR
      return null
    }

    const stringValue = value.toString();

    if (!stringValue.includes('.')) {
      return Number(stringValue);
    }

    const [integerPart, decimalPart] = stringValue.split('.');

    return Number(
      integerPart + '.' + decimalPart.substring(0, decimalPlaces)
    );
  }


  showError(message) {
    this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
    this.errormsg = message;
    setTimeout(() => {
      this.errormsg = ""
    }, this.constants.notificationMessageTimeShort);
  }

  isValueOk(param: any): boolean {
    if (param == undefined || param == null || param == "") // NOSONAR
      {return true;}
    return false;
  }

  ifNullSetZero(param) {
    return Number(param ? param : 0);

  }

}
